export interface IMonitorSalesParams extends Paths.MonitorSalesControllerGetSalesSummary.QueryParameters {
  metric?: EMonitorSalesSalesHeatmapMetric;
}

export interface IMonitorSalesSummaryModel extends Components.Schemas.CirSalesSummaryDto {}
export interface IMonitorSalesSummaryMetric extends Components.Schemas.CirMetricDto {}

export interface IMonitorSalesCategorySalesModel extends Components.Schemas.CirCategorySalesDto {}

export interface IMonitorSalesProductRatioModel extends Components.Schemas.CirProductRatioDto {}
export interface IMonitorSalesProductRatioSide extends Components.Schemas.CirProductRatioSideDto {}

export interface IMonitorSalesProductSalesModel extends Components.Schemas.CirProductSalesDto {}
export interface IMonitorSalesProductItem extends Components.Schemas.CirProductSalesItemDto {}

export interface IMonitorSalesOosOpportunityLossModel extends Components.Schemas.CirOosOpportunityLossDto {}
export interface IMonitorSalesOosItem extends Components.Schemas.CirOosItemDto {}

export interface IMonitorSalesSalesHeatmapModel extends Components.Schemas.CirSalesHeatmapDto {}
export interface IMonitorSalesHeatmapCell extends Components.Schemas.CirHeatmapCellDto {}

export enum EMonitorSalesSalesHeatmapMetric {
  TC = 'tc',
  Sales = 'sales',
  AC = 'ac',
}

export interface IOosOpportunityLossCategoryGroup {
  category: string;
  items: IMonitorSalesOosItem[];
}
